module.exports = "<div id=\"content\">\n  <div class=\"row\" id=\"content_news\">\n    <div class=\"col\" id=\"news\"><app-news></app-news></div>\n    <div class=\"col\" id=\"devblog\"><app-devblog></app-devblog></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content/content.component.html
// module id = ./src/app/components/content/content.component.html
// module chunks = main